import React from "react"
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom"
import Login from "./components/Login"
import Register from "./components/Register"
import Home from "./components/Home"
import Dashboard from "./components/Dashboard"
import SearchMovies from "./components/SearchMovies"
import MovieProfile from "./components/MovieProfile"
import ClassifyMovie from "./components/ClassifyMovie"
import DefaultLayout from "./layout/DefaultLayout"
import { AuthProvider, useAuth } from "./context/AuthContext"
import { EmotionFilterProvider } from "./context/EmotionFilterContext"

import './components/variables.css'; // Import the global CSS variables

// Classifying requires login — bounce guests to /login and remember where they were.
function RequireAuth({ children }) {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }
  return children
}

function App() {
  return (
    <AuthProvider>
      <EmotionFilterProvider>
      <Router>
        <div className="app-container">
          <DefaultLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/search" element={<SearchMovies />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/movie/:id" element={<MovieProfile />} />
              <Route
                path="/classify/:id"
                element={
                  <RequireAuth>
                    <ClassifyMovie />
                  </RequireAuth>
                }
              />
            </Routes>
          </DefaultLayout>
        </div>
      </Router>
      </EmotionFilterProvider>
    </AuthProvider>
  )
}

export default App
